import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { RpcError } from '../error/rpc.error';
import { TokenService } from '../../authentication/token.service';

@Injectable()
export class RpcService {
  private readonly jsonRpc = `${location.protocol}//${location.host.replace(
    /-web/,
    ''
  )}/PosServer/JSON-RPC`;
  private postMapCounter = 0;
  private postMap: any = {};

  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService
  ) {}

  public makeManagerCall(
    method: string,
    params?: Array<any>,
    token?: string
  ): Observable<any> {
    const token$ = token ? of(token) : this.tokenService.getToken$();
    return token$.pipe(
      switchMap(t => {
        const p = params ? [...params] : [];
        p.unshift(t);
        return this.makeGenericCall('manager.' + method, p);
      })
    );
  }

  public makeGenericCall(method: string, params: Array<any>): Observable<any> {
    const id: number = this.postMapCounter++;
    const body: string = JSON.stringify({
      id: id,
      params: params,
      method: method
    });
    const context = this.tokenService.context;

    this.postMap[id] = body;

    const headers = {
      'Content-Type': 'application/json'
    };
    if (context) {
      headers['X-Resto-Context'] = context;
    }

    return this.httpClient
      .post(`${this.jsonRpc}?${method.split('.')[1]}`, body, {
        headers: new HttpHeaders(headers)
      })
      .pipe(
        map((response: PosServerResponse) => {
          if (response.error) {
            throw new RpcError(response.error, this.postMap[response.id]);
          }

          delete this.postMap[response.id];
          return response.result;
        })
      );
  }
}

interface PosServerResponse {
  id: number;
  result: any;
  error?: any;
}
